import React from "react";

function Title() {
	return (
		<h1 className="sm:text-4xl text-3xl mb-10 text-center font-black tracking-wide text-teal-700">
			let's Find GitHub User
		</h1>
	);
}

export default Title;
